import React, { useState } from "react";
import Objective from "./Objective";
import Vertical from "./vertical/Vertical";
import Computing from "./computing/Computing";
const Shaft = (props) => {
  const [isStep, setStep] = useState("objective");

  // Leaving either plotting page returns to the menu it was chosen from.
  const toSources = (step) => setStep(step === "objective" ? "sources" : step);

  return isStep === "objective" || isStep === "sources" ? <Objective setstep={setStep} sources={isStep === "sources"} /> : isStep === "vertical_shaft" ? <Vertical setstep={toSources} /> : isStep === "computing" ? <Computing setstep={toSources} /> : "";
};
export default Shaft;
